import React from 'react';
import styles from './customError.module.css';
import IMAGES from '../../assets/images/images';

const CustomErrorPopup = ({ errorHeader,errorMessage,isnote, onClose }) => {
  return (
    <div className={styles.alertmessage}> 
      <div className={styles.alertcontent}>
      <div className={styles.header}>
      <div className={styles.errormsghead}>{errorHeader}</div>
      {/* <div className={styles.closes}> <img className={styles.close} onClick={onClose} src={IMAGES.close}/></div> */}
      </div>
        <div className={styles.errormsg}>{errorMessage}</div>
        {isnote&&<div className={styles.errornotemsg}><span className={styles.errornote}>Note:</span> Tickets raised via email cannot be monitored via the portal.</div>}
        <div className={styles.buttonok}>
        <button className={styles.buttonscan} onClick={onClose}>OK</button>
        </div>
      </div>
    </div>
  );
};

export default CustomErrorPopup;